import { gql } from '@apollo/client'

const MERGE_LAB = gql`
  mutation MERGE_LAB($lab: ID!, $newLab: ID!) {
    mergeLab(lab: $lab, newLab: $newLab) {
      id
    }
  }
`

export default MERGE_LAB
